module.exports = __webpack_public_path__ + "static/media/person-add.38c90e94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person-add.svg
// module id = 927
// module chunks = 0